import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-planReview3_operationManagementE_add",
  "use": "icon-planReview3_operationManagementE_add-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-planReview3_operationManagementE_add\"><defs></defs><path class=\"a\" d=\"M75.538,133.538H70.462v-5.077a.462.462,0,1,0-.923,0v5.077H64.462a.462.462,0,1,0,0,.923h5.077v5.077a.462.462,0,0,0,.923,0v-5.077h5.077a.462.462,0,1,0,0-.923Z\" transform=\"translate(-64 -128)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol